module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 001-208c3a129884df8c40bb228ddca0af25.png";